module.exports = __webpack_public_path__ + "img/pago.6c59ab5f.png";